import styled from 'styled-components'

import { panelCss } from 'components/page/PhotoViewer/Panel/Panel.styled'
import { media } from 'components/presentational'

export const Wrapper = styled.div`
  ${panelCss};
  bottom: 20px;

  ${media.tablet`
    bottom: 10px;
  `};
`
